import logErrorsMiddleware from './logErrorsMiddleware';
import timerMiddleware from './timerMiddleware';
import Middleware from '../Middleware';
var devTools = process.env.NODE_ENV !== 'production' ? logErrorsMiddleware.concat(timerMiddleware(function () {
  return Date.now();
})) : Middleware.EMPTY;
export default devTools;